import useTranslation from 'next-translate/useTranslation';
import styles from './styles.module.scss';
import { FormGroup, Input } from '@starsoft/common/components';
import { useGameReportData } from '@/hooks/gameReport/useGameReportData';
import { GameID } from '@/enums/gameId';

export default function GameReportModalContentMinesDetails() {
  const { t } = useTranslation('game-report');
  const { bets, game, isPending } = useGameReportData();

  if (game?.id?.toString() !== GameID.Mines?.toString()) {
    return null;
  }

  return (
    <div className={styles.container}>
      <FormGroup
        label={t('mines_count')}
        isLoading={isPending}
        loading={{ label: true, secondary: true }}
      >
        <Input
          isContainerColor
          readOnly
          isLoading={isPending}
          value={bets?.[0]?.grid?.difficulty?.mines?.minesCount}
        />
      </FormGroup>
      <FormGroup
        label={t('gems_count')}
        isLoading={isPending}
        loading={{ label: true, secondary: true }}
      >
        <Input
          isContainerColor
          readOnly
          isLoading={isPending}
          value={25 - Number(bets?.[0]?.grid?.difficulty?.mines?.minesCount)}
        />
      </FormGroup>
    </div>
  );
}
